<template>
    <div>
        <input type="file" ref="myFiles" class="invisible" v-on:change="loadSelectedFiles" multiple />
        <cogi-button cssClassButton="parcourir" text="Parcourir" v-on:click="parcourirClick" />
    </div>
</template>

<script setup lang="ts">
    import { useTemplateRef } from 'vue'
    import CogiButton from './CogiButton.vue'

    const model = defineModel<Array<File>>()

    const myFiles = useTemplateRef<HTMLInputElement>('myFiles')

    function getFiles() {
        return Array.from(myFiles.value?.files ?? [])
    }

    function loadSelectedFiles() {
        model.value!.push(...getFiles())

        // On enlève les fichiers à l'élément "<input type="file" ..." pour éviter que Chrome empêche
        // l'ajout d'un fichier déjà ajouté, à l'occasion (DL-374).
        myFiles.value!.value = ''
    }

    function parcourirClick() {
        myFiles.value!.click()
    }
</script>
